import { useMemo, useEffect } from "react";
import { IFormSection, TFormHookParams } from "../../../types/common";

interface ICustomerReportRequestsFormParams
  extends Omit<TFormHookParams, "searchParams" | "form_params"> {}

const useCustomerReportRequestsForm = ({
  form,
  updateFormValues,
  id,
}: ICustomerReportRequestsFormParams = {}) => {
  const isUpdate = Boolean(id);

  const initialValues = useMemo(
    () => ({
      user_number: "",
      request_type: "AccountStatement",
      target_email: "",
      start_date: "",
      end_date: "",
    }),
    [],
  );

  useEffect(() => {
    if (updateFormValues && !isUpdate && !form?.request_type) {
      updateFormValues(initialValues);
    }
  }, [updateFormValues, isUpdate, form?.request_type, initialValues]);

  const today = new Date().toISOString().split("T")[0];

  const sections: IFormSection[] = [
    {
      title: "Report Request Details",
      fields: [
        {
          field_name: "user_number",
          type: "text",
          label: "User Number",
          props: {
            required: true,
            placeholder: "Enter merchant/agent/public user number",
          },
        },
        {
          field_name: "request_type",
          type: "select",
          label: "Report Type",
          props: {
            required: true,
            disabled: true,
          },
          options_data: [{ id: "AccountStatement", name: "Account Statement" }],
        },
        {
          field_name: "target_email",
          type: "email",
          label: "Target Email",
          props: {
            required: true,
            placeholder: "Enter email to receive the report",
          },
        },
        {
          field_name: "start_date",
          type: "date",
          label: "Start Date",
          props: {
            required: true,
            max: today,
          },
        },
        {
          field_name: "end_date",
          type: "date",
          label: "End Date",
          props: {
            required: true,
            min: form?.start_date,
            max: today,
          },
        },
      ],
    },
  ];

  return {
    sections,
    title: "Customer Report Request",
    defaultValues: {
      request_type: "AccountStatement",
    },
  };
};

export default useCustomerReportRequestsForm;
